export default __webpack_public_path__ + "static/media/Limit.fd405368.svg";